import React, {Component} from 'react'
import {DatePicker, Form, Modal} from 'antd'
import {Input} from 'antd/lib/index'

const {TextArea} = Input

class TerminationForm extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    return (
      <Form>
        <Form.Item label="Termination Date" {...formItemLayout}>
          {getFieldDecorator('date.terminated', {
            rules: [
              {
                required: true,
                message: "Termination Date can't be empty ",
              },
            ],
          })(
            <DatePicker
              style={{width: '100%'}}
              placeholder="Termination Date"
            />,
          )}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Reason">
          {getFieldDecorator('termination', {
            rules: [
              {
                required: true,
                message: "Reason By can't be empty ",
              },
            ],
          })(<TextArea />)}
        </Form.Item>
      </Form>
    )
  }
}

class TerminationModal extends Component {
  render() {
    const WrappedForm = Form.create()(TerminationForm)
    const {
      visibleTermination,
      onCancelTermination,
      terminationFormRef,
      terminate,
      terminating,
    } = this.props
    return (
      <Modal
        title={`Terminate Contract`}
        visible={visibleTermination}
        onCancel={onCancelTermination}
        onOk={terminate}
        confirmLoading={terminating}
        okText={'Terminate'}
        destoryOnClose={true}
        width={700}>
        <WrappedForm {...this.props} wrappedComponentRef={terminationFormRef} />
      </Modal>
    )
  }
}

TerminationModal.propTypes = {}
TerminationModal.defaultProps = {}

export default TerminationModal
